export default [{
  path: '/simulacao/:context',
  component: () => import('@/feature/prequalify/views/Template.vue'),
  children: [{
    path: '/simulacao/:context/info',
    name: 'prequalify-simulation',
    component: () => import('@/feature/prequalify/views/Simulation.vue'),
  },
  {
    path: '/simulacao/:context/dados',
    name: 'prequalify-form',
    component: () => import('@/feature/prequalify/views/Form.vue'),
  },
  {
    path: '/simulacao/:context/aprovado',
    name: 'prequalify-approved',
    component: () => import('@/feature/prequalify/views/Approved.vue'),
  },
  {
    path: '/simulacao/:context/negado',
    name: 'prequalify-reproved',
    component: () => import('@/feature/prequalify/views/Reproved.vue'),
  }],
}];
